import * as React from "react";
import {Fragment} from "react";
import InvoiceCreatedNotification from "../../../model/notification/invoice/InvoiceCreatedNotification";

interface ComponentProps {
	/**
	 * Notification to display in toaster.
	 */
	notification: InvoiceCreatedNotification;
}

/**
 * Invoice created notification toast body.
 */
const NotificationInvoiceCreatedBody: React.SFC<ComponentProps> = (props) => {
	return (
		<Fragment>
			<div className={"toast-header"}>Invoice {props.notification.data.jobRefNumber}</div>
			<div className={"toast-body"}>
				Invoice has been created
			</div>
		</Fragment>
	);
};

export default NotificationInvoiceCreatedBody;
